export const radians = Math.PI / 180;
export const degrees = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// ./~/d3-color/src/math.js
// module id = 170
// module chunks = 0